module.exports = __webpack_public_path__ + "components/discount-pages/roadsurfer/static/roadsurfer-1920-1a08dba0a8d2403427084cd19e28d2a8.webp";